/**
 * Routers used for regular pages
 **/
import Backbone from 'backbone';
import ExtranetView from './pages/extranet';
import TradeReportView from './pages/tradereport';
import TransactionReportView from './pages/transactionreport';
import AdminDashboardView from './pages/admin-dashboard';
import ParticipantIndexView from './pages/participant-index';
import ParticipantEditView from './pages/participant-edit';
import BillingView from './pages/billing';
import SettingsView from './pages/settings';
import InstrumentSettingsView from './pages/instrument-settings';
import BulkUploadView from './pages/bulk-upload';

export default Backbone.Router.extend({

	views: {},

	routes: {
		// Checked
		'tradereporting(/:action/:id)': 'reportTrade',
		'tradereporting/queue': 'reportTrade',
		'tradereporting/save': 'reportTrade',

		'transactionreporting(/:action/:id)': 'reportTransaction',
		'transactionreporting/queue': 'reportTransaction',
		'transactionreporting/save': 'reportTransaction',

		// Not checked
		'admin': 'adminDashboard',
		'participants': 'participants',
		'participants/create': 'participantEdit',
		'participants/edit(:id)': 'participantEdit',
		'billing': 'billing',

		// Checked
		'settings': 'settings',
		'settings/editprice(:id)': 'settings',

		'instrumentsettings': 'instrumentSettings',

		// Checked
		'bulkupload': 'bulkUpload'
	},

	initialize: function() {
		// always create the extranet page view
		this.page = new ExtranetView({
			el: '.js-extranet'
		});
	},

	// PARTICIPANT PAGES
	// trade report page
	reportTrade: function() {
		this.view = new TradeReportView({
			el: '.js-report'
		}).render();
	},

	reportTransaction: function() {
		this.view = new TransactionReportView({
			el: '.js-report'
		}).render();
	},

	// ADMIN PAGES
	adminDashboard: function() {
		this.view = new AdminDashboardView({
			el: '.admin-dashboard'
		}).render();
	},

	// list with participants
	participants: function() {
		this.view = new ParticipantIndexView({
			el: '.js-participants'
		}).render();
	},

	// edit a participant, includes a tabbed view
	participantEdit: function() {
		this.view = new ParticipantEditView({
			el: '.js-participant-edit'
		});
	},

	billing: function() {
		this.view = new BillingView({
			el: '.js-billing'
		});
	},

	settings: function() {
		this.view = new SettingsView({
			el: '.js-settings'
		});
	},

	instrumentSettings: function() {
		// InstrumentSettingsView
		this.view = new InstrumentSettingsView({
			el: '.js-settings'
		});
	},

	bulkUpload: function() {
		this.view = new BulkUploadView({
			el: '.js-button-download'
		});
	}
});

